// The file contents for the current environment will overwrite these during build.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,
    AuthConfig: {
        partnerApiUrl: 'https://rmm-third-party-integration.api',
        clientID: 'bRJ9DQ2dYfWYNRHLaCDDJja7VcBiNhc4',
        domain: 'fmw8.jp.auth0.com', // Domain Path: Auth0 -> Applications -> Settings -> Domain
        callbackURL: location.origin + '/#/callback',   // Allowed Callback URLs Path: Auth0 -> Applications -> Settings -> Allowed Callback URLs
        apiUrl: 'https://marvel-portal.invalid', // Audience Path :Auth0 -> API -> Settings -> General Settings -> Identifier
        azure_app_client_id: '8b610388-b0be-4f79-8b17-4803bfe26b5a' // AAD -> App Registration -> Application (client)
    },
    scpCommonApiBaseUrl: {
        url: 'https:///api',
    },
    sspLicenseApi: {
        url: 'https://dev8-smartoffice-api.sharpb2bcloud.com/lic/v1'
    },

    sspAgentApi: {
        url: 'https://dev8-smartoffice-api.sharpb2bcloud.com/agent/management/v1'
    },
    sspMarvelAgentApi: {
        url: 'https://dev8-agentdl.sharpb2bcloud.com'
    },
    sccCommonApiBaseUrl: {
        url: 'https:///api',
    },
    micasDashboardUrl: 'https://', // MICAS dashboard base URL (US only)
    rmpEndPoint: {
        url: 'https://dev8-smartoffice-api.sharpb2bcloud.com/rmi/v1/rooms/'
    },
    rmpEndPointToken: {
        url: 'https://dev8-smartoffice-api.sharpb2bcloud.com/rmi/v1/token'
    },
    rmpEndPointUser: {
        url: 'https://dev8-smartoffice-api.sharpb2bcloud.com/rmi/v1'
    },
    deviceEndPoint: {
        url: 'https://dev8-smartoffice-api.sharpb2bcloud.com/rmi/v1/devices',
    },
    rmpEndPointLicense: {
        url: 'https://dev8-smartoffice-api.sharpb2bcloud.com/lic/v1/license'
    },
    rmpEndPointSubscription: {
        url: 'https://dev8-smartoffice-api.sharpb2bcloud.com/lic/v1/subscription'
    },
    rmpEndPointTenant: {
        url: 'https://dev8-smartoffice-api.sharpb2bcloud.com/lic/v1/tenantInfo'
    },
    logReportUrl: {
        url: 'https://dev8-smartoffice-api.sharpb2bcloud.com/rmi/v1/graph/so'
    },
    exportlogUrl: {
        url: 'https://dev8-smartoffice-api.sharpb2bcloud.com/rmi/v1/csv/so',
    },
    rmpEndPointNotificationPreferences: {
        url: 'https://dev8-smartoffice-api.sharpb2bcloud.com/marvel/v1/subscriptions/',
    },
    domainsURL: {
        url: 'https://dev8-smartoffice-api.sharpb2bcloud.com/lic/v1/domainsAliasInfo',
    },
    sspCommonEndPoint: {
        url: 'https://dev8-smartoffice-api.sharpb2bcloud.com/rmi/v1'
    },
    marvelEndPoint: {
        url: 'https://dev8-smartoffice-api.sharpb2bcloud.com/marvel/v1'
    },
    marvelAgentDownloadEndPoint: {
        url: 'https://dev8-agentdl.sharpb2bcloud.com'
    },
    marvelAgentLogErrorsPoint: {
        url: 'https://dev8-smartoffice-api.sharpb2bcloud.com/errorlog/v1'
    },
    selectProviderURL: {
        url: 'https://dev8-smartoffice-api.sharpb2bcloud.com/lic/v1/events/tenantCreation',
    },
    logstashUrl: {
        url: 'https://dev8-smartoffice-api.sharpb2bcloud.com/rmi/v1/logstash',
    },
    auditLogElasticSearch: {
        url: 'https://dev8-smartoffice-api.sharpb2bcloud.com/rmi/v1/elasticsearch',
    },
    vender: [
        { value: 'ClickShare', viewValue: 'ClickShare' },
        { value: 'Miracast', viewValue: 'Miracast' },
        { value: 'MirrorOp', viewValue: 'MirrorOp' },
        { value: 'Google Cast', viewValue: 'Google Cast' }
    ],
    go_app_store: {
        url: 'https://apps.apple.com/us/app/synappx-go/id1471039167'
    },
    go_play_store: {
        url: 'https://play.google.com/store/apps/details?id=jp.co.sharp.bs.smartoffice.synappxgomobile'
    },
    sspEsignageEndPoint: {
        url: 'https://dev8-signage-api.sharpb2bcloud.com/'
    },
    googleScopes: [
        'https://www.googleapis.com/auth/admin.directory.domain.readonly',
        'https://www.googleapis.com/auth/admin.directory.group.readonly',
        'https://www.googleapis.com/auth/admin.directory.resource.calendar.readonly',
        'https://www.googleapis.com/auth/admin.directory.user.readonly',
        'https://www.googleapis.com/auth/userinfo.profile'
    ],
    googleTagEnable: 'false',
    googleTagId: '',
    stackRegion: 'JP',
    privacyUrl: 'https://business.sharpusa.com/synappx-support/about/privacy',
    termsUseUrl: 'https://business.sharpusa.com/synappx-support/about/termsofuse',
    helpUrl: 'https://business.sharpusa.com/synappx-support',
    castingSystemRequirementUrl: "https://business.sharpusa.com/synappx-support/Synappx-Meeting/System-Requirements",
    roomLimit : 100,
    version: '4.20.200-beta.5-SNAPSHOT-20261026-052800',
    oldAgentVersion: '1.0.64.0',
    userLimit: 5000,
    retryIntervalForHttp429: 1000,
    checkInStartDate: new Date(2020, 6, 1),
    agentMinVersion: { 'mfpAgent': '3.5.0.0', 'displayAgent': '3.5.0.0' },
    esignageAgentAndPlayerMinVersion: { 'eSignageAgent': '0.0.0.0', 'eSignageplayer': '0.0.0.0' },
    optional: {
        feat_v33: 'true',
        feat_v36: 'true',
        // flag used for rmm version check
        feat_RMM14: 'false',
        feat_v341: 'true',
        feat_scpv1: 'false',
    },
    show_sharp_start: 'false',
    sharpstart_logout_url: 'https://startrmm.sharpusa.net/DesktopModules/Inventua%20-%20Custom%20Login%20Services/1.0/Oauth2Logout.ashx',
    signageAppUrl: 'https://dev8-cms.sharpb2bcloud.com',
    provisionSubscriptionKey: '0bb8da6b2edc466888dd2239d46d6cd5',
    deployedDate: '2026-10-26T05:28:31Z',
};
